import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, identityClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const getBusinessGroupQuantityDatatable: ApiMethod<
  Server.BusinessGroupQuantitiesDataTableInput,
  Server.TableOfBusinessGroupQuantityColumns,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroupQuantity_Client(
      undefined,
      identityClient
    );
    const response = await client.admin_BusinessGroupQuantity_datatable_post_V1(
      data
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const createNewBusinessQuantity: ApiMethod<
  Server.AddBusinessGroupQuantityInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroupQuantity_Client(
      undefined,
      identityClient
    );
    const response = await client.admin_BusinessGroupQuantity_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
